import { createAction } from '@reduxjs/toolkit';

import { NAME } from './constants';

export const cancelPlan = createAction<{ feedback: string }>(`${NAME}/cancelPlan`);
